<div
  class="contenedor-div"
  [ngClass]="getClase()" >
  <div
    appCurrentColor
    [backgroundColor]="true"
    class="container-header color_blanco">
    <span>
      <span class="k-icon k-i-question"></span>
      {{ "labels.informacion" | translate }}
    </span>
  </div>
  <div *ngIf="textoBox"
    class="p-2 text-new-10 text-justify content-scroll"
    [innerHtml]="textoBox | translate | returnHtml: 'html'" ></div>

  <div *ngIf="_textoInfo"
    class="p-2 text-new-10 text-justify content-scroll"
    [innerHtml]="_textoInfo | returnHtml: 'html'" ></div>

</div>
